import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken, getUserName} from '@/utils/auth'
import router from "@/router";

// 在文件顶部添加
let refreshLoginPromise = null;
let hasShownErrorMessage = false;

// create an axios instance
const service = axios.create({
    baseURL: 'api', // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['token'] = getToken()
        }

        // if (sessionStorage.getItem('userName')) {
        //     // let each request carry token
        //     // ['X-Token'] is a custom headers key
        //     // please modify it according to the actual situation
        //     config.headers['userName'] = sessionStorage.getItem('userName')
        // }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        // if the custom code is not 20000, it is judged as an error.
        if (res.result && res.result !== 1) {
            if (res.result !== -9 && !hasShownErrorMessage) {
                hasShownErrorMessage = true;
                Message({
                    message: res.remark || 'Error',
                    type: 'error',
                    duration: 5 * 1000
                })
                // 延迟重置标志位，避免短时间内重复显示
                setTimeout(() => {
                    hasShownErrorMessage = false;
                }, 1000);
            }

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.result === -9) {
                // 如果已经有正在处理的登录确认，则返回同一个Promise
                if (!refreshLoginPromise) {
                    refreshLoginPromise = MessageBox.confirm('登录过期请重新登录', {
                        confirmButtonText: '去登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        router.push({path: '/'})
                    }).catch(() => {
                        // 用户取消操作
                    }).finally(() => {
                        // 清空Promise，允许下次重新登录确认
                        refreshLoginPromise = null;
                    });
                }
                return refreshLoginPromise.then(() => {
                    return Promise.reject(new Error(res.result || 'Error'));
                });
            }
            return Promise.reject(new Error(res.result || 'Error'))
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.result,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js